import * as Types from '../generated/graphql';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
const defaultOptions = {} as const;
export type GetWebAiChatMessagesQueryVariables = Types.Exact<{
  aiChatId: Types.Scalars['String']['input'];
}>;


export type GetWebAiChatMessagesQuery = { __typename?: 'query_root', getWebAiChatMessages?: Array<{ __typename?: 'webAiChatMessageOutput', id: string, message: string, isSystem: boolean, createdAt: string, userId?: string | null, chatId: string, user?: { __typename?: 'users', id: string, firstName: string, lastName: string, profilePhotoLink?: string | null } | null, webAiChat?: { __typename?: 'webAiChats', id: any, aiChatId: string, workspaceId?: number | null, partitionId?: string | null, organizationId?: string | null, createdAt?: any | null } | null } | null> | null };


export const GetWebAiChatMessagesDocument = gql`
    query getWebAiChatMessages($aiChatId: String!) {
  getWebAiChatMessages(chatId: $aiChatId) {
    id
    message
    isSystem
    createdAt
    userId
    user {
      id
      firstName
      lastName
      profilePhotoLink
    }
    chatId
    webAiChat {
      id
      aiChatId
      workspaceId
      partitionId
      organizationId
      createdAt
    }
  }
}
    `;

/**
 * __useGetWebAiChatMessagesQuery__
 *
 * To run a query within a React component, call `useGetWebAiChatMessagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetWebAiChatMessagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetWebAiChatMessagesQuery({
 *   variables: {
 *      aiChatId: // value for 'aiChatId'
 *   },
 * });
 */
export function useGetWebAiChatMessagesQuery(baseOptions: Apollo.QueryHookOptions<GetWebAiChatMessagesQuery, GetWebAiChatMessagesQueryVariables> & ({ variables: GetWebAiChatMessagesQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetWebAiChatMessagesQuery, GetWebAiChatMessagesQueryVariables>(GetWebAiChatMessagesDocument, options);
      }
export function useGetWebAiChatMessagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetWebAiChatMessagesQuery, GetWebAiChatMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetWebAiChatMessagesQuery, GetWebAiChatMessagesQueryVariables>(GetWebAiChatMessagesDocument, options);
        }
export function useGetWebAiChatMessagesSuspenseQuery(baseOptions?: Apollo.SuspenseQueryHookOptions<GetWebAiChatMessagesQuery, GetWebAiChatMessagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useSuspenseQuery<GetWebAiChatMessagesQuery, GetWebAiChatMessagesQueryVariables>(GetWebAiChatMessagesDocument, options);
        }
export type GetWebAiChatMessagesQueryHookResult = ReturnType<typeof useGetWebAiChatMessagesQuery>;
export type GetWebAiChatMessagesLazyQueryHookResult = ReturnType<typeof useGetWebAiChatMessagesLazyQuery>;
export type GetWebAiChatMessagesSuspenseQueryHookResult = ReturnType<typeof useGetWebAiChatMessagesSuspenseQuery>;
export type GetWebAiChatMessagesQueryResult = Apollo.QueryResult<GetWebAiChatMessagesQuery, GetWebAiChatMessagesQueryVariables>;